<template>
    <a v-if="loginStatus" @click="logout" class="nav-link" href="#">Beenden
        <span class="sr-only">(current)</span>
    </a>
</template>

<script>

    export default {
        name: "logout-btn",

        computed: {
            loginStatus () {
                return this.$store.getters.getLoginStatus
            }
        },

        methods: {
            logout () {

                this.$swal({
                    text: 'Sie werden abgemeldet..',
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                    buttons: false,
                })

                setTimeout(() => {
                    this.$RestClient.logout()
                        .then(() => {
                            this.$store.commit('resetStore')
                            this.$swal.close()
                        })
                },1500)
            }
        }
    }
</script>